import { Pipe, PipeTransform } from '@angular/core';
import { OrderStatus } from '../models';

/**
 * Maps the order status number to a human-readable string.
 * @param value The order status number.
 * @returns The corresponding order status string.
 */
@Pipe({
  name: 'orderstatus',
  standalone: true
})
export class OrderStatusPipe implements PipeTransform {
  /** Maps the Status no. with status from backend */
  ORDER_STATUS_TEXT: Record<OrderStatus, string> = {
    0: 'pipes.orderstatus.notEdited',
    1: 'pipes.orderstatus.confirmed',
    2: 'pipes.orderstatus.canceled',
    3: 'pipes.orderstatus.ready',
    4: 'pipes.orderstatus.inProcess',
    5: 'pipes.orderstatus.replacement'
  };

  transform(value: OrderStatus): string {
    if (value >= 0 && value in this.ORDER_STATUS_TEXT) {
      return this.ORDER_STATUS_TEXT[value];
    }
    return 'Unknown Status';
  }
}
